import { Base64 } from 'js-base64'
import { request } from 'network'
import { PLATFORM_CONFIG } from 'platform-config'
import { getDomain } from 'utils'
import { useConfigWatchEffect } from '../hooks'
import { StorageIndexDBEnum } from '../storage/StorageDB'
import { useIpRestrictStore } from './use-ip-restrict'

export const useEnvStore = defineStore('envStore', () => {
  const _config = window.localStorage.getItem(StorageIndexDBEnum.Config) ? JSON.parse(window.localStorage.getItem(StorageIndexDBEnum.Config)!) : {}
  const config = ref<ApiResponse.SiteConfig>(_config)
  const isReady = ref(_config ? true : false)
  const appId = ref('')
  const appKey = ref('')

  /** 解析appInfo */
  const parseAppInfo = () => {
    const appInfo = config.value.appInfo
    const tempInfo = appInfo[0].slice(2) + appInfo[1]
    const webAppIdKeyInfo = JSON.parse(Base64.decode(tempInfo))
    appId.value = webAppIdKeyInfo.app_id
    appKey.value = webAppIdKeyInfo.app_key
  }

  const fetchConfig = async () => {
    if (Object.keys(_config).length > 0) {
      parseAppInfo()
    }
    const domain = getDomain()
    const res = await request.post<ApiResponse.SiteConfig>(`${domain}/Site/config`, { __flush_cache: 1 })
    if (res.status === 200) {
      isReady.value = true
      config.value = res.data
      // config.value.downloadAppInfo.defultTestFlightUrl = 'https://testflight.apple.com/join/ymqcEZwj'
      window.localStorage.setItem(StorageIndexDBEnum.Config, JSON.stringify(res.data))
      parseAppInfo()

      // 设置 IP 限制状态
      const ipRestrictStore = useIpRestrictStore()
      ipRestrictStore.setIpRestricted(!!res.data.isSpecificCountryIp)

      useConfigWatchEffect(async () => {
        PLATFORM_CONFIG.loadExternalConfig?.()
      })
    }
  }

  const waitForConfig = (timeout = 10000) => {
    return new Promise((resolve, reject) => {
      const startTime = Date.now()

      const checkConfig = () => {
        if (config.value && Object.keys(config.value).length) {
          resolve(true)
          return
        }

        if (Date.now() - startTime > timeout) {
          reject(new Error('等待配置超时'))
          return
        }

        setTimeout(checkConfig, 50)
      }

      checkConfig()
    })
  }

  onBeforeMount(() => {
    fetchConfig()
  })

  const isEmptyConfig = computed(() => {
    return Object.keys(config.value).length === 0
  })

  // useChangeLanguage(fetchConfig)

  return {
    isReady,
    config,
    appId,
    appKey,
    fetchConfig,
    waitForConfig,
    isEmptyConfig
  }
})
